import { ProgramFavoriteTypeEnum } from './program-favorite-type.enum';

export class ProgramFavoriteRequest {
    constructor(public favoriteType: ProgramFavoriteTypeEnum,
                public entityIds: Array<number>) {
    }
}
